module.exports = __webpack_public_path__ + "static/compare-movies.fb04962c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/compare-movies.jpg
// module id = 69
// module chunks = 35783957827783 213720915766396 268472206294114